import type { Mutation, MutationDeleteKanbanLabelSetArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { DELETE_KANBAN_LABEL_SET } from './gql/deleteKanbanLabelSet';
import { GET_KANBAN_LABEL_SETS } from './gql/getKanbanLabelSets';

type MutationDataType = Pick<Mutation, 'deleteKanbanLabelSet'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('deleteKanbanLabelSet');

const refetchQueries = [GET_KANBAN_LABEL_SETS];

export const useDeleteKanbanLabelSet = (id: string) => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [deleteKanbanLabelSet, { loading, error, data }] = useMutation<
        MutationDataType,
        MutationDeleteKanbanLabelSetArgs
    >(DELETE_KANBAN_LABEL_SET, {
        variables: { id },
        refetchQueries,
        onError
    });

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        error: !!error && !loading,
        success: !!data && !loading,
        deleteKanbanLabelSet,
        loading,
        response
    };
};
